import React, { useEffect, useState } from "react";
import MainHeading from "../../components/comman/MainHeading";
import PlusIcon from "../../components/Icons/PlusIcon";
import EditIcon from "../../components/Icons/EditIcon";
import ViewIcon from "../../components/Icons/ViewIcon";
import DeleteIcon from "../../components/Icons/DeleteIcon";
import { MainFilterHandler } from "../../components/comman/MainFilterHandler";
import { toast } from "react-toastify";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { callApi } from "../../ApiHelper/ApiHelper";
import PaginationComponent from "../../components/comman/PaginationComponent";
import moment from "moment";
import { handlePriorityStatus } from "../../utility/CommonFunctions";
import NoRecordIcon from "../../components/Icons/NoRecordIcon";
import ConfirmModal from "../../components/comman/ConfirmModal";
import { useSelector } from "react-redux";
import CreateMeetingModal from "./CreateMeetingModal";
import { Spinner } from "reactstrap";
import MeetingDetailModal from "./MeetingDetailModal";

function MeetingManagement({ localDateFilter }) {
    const userDetails = useSelector((state) => state.root.userDetails);
    const filterDetails = useSelector((state) => state.root.filtersStates);
    const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const [modal, setModal] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const toggleModal = () => {
        setModal(!modal);
    };
    const [selectedId, setSelectedId] = useState("");
    const toggleAddEditModal = () => setIsAddEditModalOpen(!isAddEditModalOpen);
    const toggleDetailModal = () => setIsDetailModalOpen(!isDetailModalOpen);

    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        meetingList: [],
        status: '',
        searchQuery: '',
        year: filterDetails?.year || '',
        siteId: filterDetails?.siteId || '',
        sortByDate: localDateFilter || [],
        isLoadingMeeting: false,
        statusCounts: {
            cancelled: 0,
            done: 0,
            inProgress: 0,
        },
    });

    useEffect(() => {
        setPageStates((prev) => ({
            ...prev,
            year: filterDetails?.year,
            siteId: filterDetails?.siteId,
            sortByDate: localDateFilter,
            currentPage: 1,
        }));
    }, [filterDetails?.year, filterDetails?.siteId, localDateFilter]);

    useEffect(() => {
        getMeetingList(true);
    }, [pageStates?.currentPage, pageStates?.pageSize, pageStates?.status, pageStates?.year, pageStates?.sortByDate, pageStates?.siteId]);

    const getMeetingList = () => {
        let options = {
            method: "GET",
        };

        const Url =
            apiUrl.get_meetings + "?" + MainFilterHandler(pageStates);
        setPageStates((pre) => ({
            ...pre,
            isLoadingMeeting: !pre.isLoadingMeeting,
        }));
        callApi(Url, options).then((res) => {
            setPageStates((pre) => ({
                ...pre,
                isLoadingMeeting: !pre.isLoadingMeeting,
            }));
            if (res?.status === true) {

                setPageStates((pre) => ({
                    ...pre,
                    meetingList: res?.data?.meetings,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                    statusCounts: {
                        cancelled: res?.data?.meetingCounts?.cancelled,
                        done: res?.data?.meetingCounts?.done,
                        inProgress: res?.data?.meetingCounts?.inProgress,
                    },
                }));

            }
            else {
                toast.error(res?.message || "Something went wrong");
            }
        });
    };

    const PageChangeHandler = (PageNo) => {
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1,
        }));
    };

    const HandleDeleteMeeting = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_meeting + `?meetingId=${selectedId}`;
        setIsLoadingDelete(true);
        callApi(API, options).then((response) => {
            setIsLoadingDelete(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggleModal();
                getMeetingList();
            } else {
                toast.error(response?.message);
                toggleModal();
            }
        });
    };

    const ActionHandler = (meeting) => {
        setSelectedId(meeting?.id);
        toggleModal();
    };

    return (
        <>
            <MainHeading
                // title="Tasks"
                buttonText="New Meeting"
                buttonIcon={<PlusIcon />}
                clickHandler={userDetails?.type != 2 ? () => {
                    setSelectedMeeting(null);
                    toggleAddEditModal()
                } : null}
            />

            <div className="d-flex flex-column gap-3 mb-5">
                {pageStates?.isLoadingMeeting ? <div style={{ height: "50vh" }} className='d-flex align-items-center justify-content-center'><Spinner /></div> : (
                    pageStates?.meetingList?.length > 0 ?
                        pageStates?.meetingList?.map(meeting => (
                            <div
                                key={meeting.id}
                                className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 bg-white"
                                style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                                onClick={() => {
                                    setSelectedMeeting(meeting);
                                    setIsDetailModalOpen(true);
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.classList.add('shadow'); e.currentTarget.classList.remove('shadow-sm'); }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.classList.add('shadow-sm'); e.currentTarget.classList.remove('shadow'); }}
                            >
                                <div className="card-body px-3 py-2">
                                    {/* Top row: Title and Status/Date */}
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <h5 className="fw-bold text-dark mb-0" style={{ letterSpacing: "-0.3px" }}>{meeting?.title}</h5>
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="d-flex align-items-center text-muted bg-light px-3 py-1 rounded-pill border" style={{ fontSize: '10px', fontWeight: '500' }}>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="me-2 text-primary" viewBox="0 0 16 16">
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                </svg>
                                                {meeting?.date ? moment(meeting?.date).format("DD MMM YYYY") : "No Date"}
                                            </div>
                                            <div className="d-flex align-items-center gap-2 pe-3 border-end">
                                                <div className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center fw-bold" style={{ width: '25px', height: '25px', fontSize: '10px' }}>
                                                    {meeting?.meetingCreator?.name ? meeting?.meetingCreator?.name.charAt(0).toUpperCase() : 'U'}
                                                </div>
                                                <div className="d-flex flex-column justify-content-center">
                                                    <span className="text-muted text-uppercase" style={{ fontSize: '10px', fontWeight: '600', letterSpacing: '0.5px', lineHeight: '1' }}>Created By</span>
                                                    <span className="text-dark fw-bold" style={{ fontSize: '10px', lineHeight: '1.2' }}>{meeting?.meetingCreator?.name || "Unknown"}</span>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    {/* Middle row: Agenda */}
                                    <div className="mb-2">
                                        <p className="mb-0 text-secondary" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                            {meeting?.agenda || "No agenda provided."}
                                        </p>
                                    </div>

                                    {/* Bottom row: Joinees and Actions */}
                                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-1 border-top pt-2 gap-2">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="d-flex align-items-center text-muted bg-light px-3 py-2 rounded-3 border" style={{ fontSize: '10px', fontWeight: '500' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="me-2 text-primary" viewBox="0 0 16 16">
                                                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                    <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z" />
                                                    <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                                                </svg>
                                                {meeting?.joinees?.length || 0} Joinees
                                            </div>
                                            {meeting?.sites?.length > 0 && <div className="d-flex align-items-center text-muted bg-light px-3 py-2 rounded-3 border" style={{ fontSize: '10px', fontWeight: '500' }}>
                                                <i className="bi bi-sun text-primary me-2"></i>
                                                {meeting?.sites?.length || 0} Sites
                                            </div>}
                                            {meeting?.tasks?.length > 0 && (
                                                <div className="d-flex align-items-center text-muted bg-light px-3 py-2 rounded-3 border" style={{ fontSize: '10px', fontWeight: '500' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="me-2 text-primary" viewBox="0 0 16 16">
                                                        <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                                                        <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z" />
                                                    </svg>
                                                    {meeting?.tasks?.length} Tasks
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-2">
                                            {userDetails?.id === meeting?.meetingCreator?.id && (
                                                <button type='button'
                                                    className='btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center border-0' style={{ width: '25px', height: '25px', transition: 'all 0.2s', backgroundColor: '#f1f5f9' }} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e2e8f0'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedMeeting(meeting);
                                                        setIsAddEditModalOpen(true);
                                                    }}>
                                                    <EditIcon />
                                                </button>
                                            )}
                                            {userDetails?.id === meeting?.meetingCreator?.id && (
                                                <button
                                                    type='button'
                                                    className='btn btn-light text-danger rounded-circle p-2 d-flex align-items-center justify-content-center border-0' style={{ width: '25px', height: '25px', transition: 'all 0.2s', backgroundColor: '#fee2e2' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fecaca'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fee2e2'}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        ActionHandler(meeting);
                                                    }}>
                                                    <DeleteIcon />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        : <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error my-5">
                            <NoRecordIcon />
                            {"No Meeting found"}
                        </div>
                )}
            </div>

            {/* pagination */}
            <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                <div className="d-flex align-items-center gap-2">
                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                        <div className="dropdown short">
                            <button
                                className="btn dropdown-toggle border"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {pageStates?.pageSize}
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                            stroke="#36394A"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></path>
                                    </svg>
                                </span>
                            </button>
                            <ul className="dropdown-menu ">
                                {[10, 20, 30, 40, 50].map((value) => (
                                    <li key={value}>
                                        <button
                                            className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                                }`}
                                            onClick={() => handleChangePageSize(value)}
                                        >
                                            {value}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div>
                        {pageStates?.count > 0 && !pageStates?.tableLoader && (
                            <p
                                className="mb-0 text-muted fw-medium text-uppercase"
                                style={{ fontSize: "10px" }}
                            >
                                {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                                    (pageStates?.pageSize - 1)
                                    } to ${pageStates?.currentPage * pageStates?.pageSize <
                                        pageStates?.count
                                        ? pageStates?.currentPage * pageStates?.pageSize
                                        : pageStates?.count
                                    } of ${pageStates?.count} entries`}
                            </p>
                        )}
                    </div>
                </div>

                <PaginationComponent
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    totalPages={pageStates?.totalPages}
                />
            </div>

            <CreateMeetingModal isOpen={isAddEditModalOpen} toggle={toggleAddEditModal} selectedMeeting={selectedMeeting} getMeetingList={getMeetingList} />
            <MeetingDetailModal isOpen={isDetailModalOpen} toggle={toggleDetailModal} selectedMeeting={selectedMeeting} />

            <ConfirmModal
                modal={modal}
                toggle={() => toggleModal()}
                submitHandler={HandleDeleteMeeting}
                isLoading={isLoadingDelete}
            />
        </>
    );
}

export default MeetingManagement;
